const handleDeleteFrequencyFormParamFreq = {
  confirm: 'Do you really want to delete the item',
  title: 'DELETE ITEM'
};

export default handleDeleteFrequencyFormParamFreq;
